
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLocation2 as ObiLocation2Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-location-2.js';
 
 
 

 
 export const ObiLocation2 = createComponent({
   react: React,
   tagName: 'obi-location-2',
   elementClass: ObiLocation2Element,
   events: {
     
   }
  });
 
 